import { createBrowserHistory, History } from 'history';
import { Config } from './Config';

export const createHistory = (config: Config): History =>
  createBrowserHistory({ forceRefresh: config.forceRefreshRouting });
